import { createFileRoute } from '@tanstack/react-router';
import PersonalDataPhone from '@/features/account/profile/personal-data/phone';

export const Route = createFileRoute('/perfil/dados-pessoais/celular')({
  component: PersonalDataPhone,
  staticData: { subtitle: 'Celular' },
});
